import React, {Component} from 'react';
import "./Cooperation.scss"
import Navs from "../../components/Navs/Navs";
import ComTitle from "../../components/ComTitle/ComTitle";
import {titleObj} from "../../config/configPublic";
import Footer from "../../components/Footer/Footer";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Autoplay, Navigation, Pagination} from "swiper";

SwiperCore.use([Navigation,Pagination, Autoplay]);

class Cooperation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            picUrl: ""
        }
    }

    componentDidMount() {
        this.getCooperationList();
    }

    getCooperationList() {
        this.$axios.apiList.getCooperationList({})
            .then(res => {
                this.setState({
                    dataList: res.data.cpsList,
                    picUrl: res.data.picUrl
                })
            })
            .catch(error => {

            })
    }

    render() {
        let {dataList, picUrl} = this.state;
        return (
            <div className="cooperation">
                <div className="navs">
                    <Navs fullPageIndex={6}></Navs>
                </div>
                <div className="picUrl">
                    <img src={picUrl} alt=""/>
                </div>
                <ComTitle {...titleObj.cooperation}></ComTitle>
                <div className="content">
                    <div className="cooperation-swiper">
                        <Swiper
                            // className="swiper-no-swiping"
                            initialSlide={0}   //初始化时的索引位置
                            speed={1000} //页面切换速度，slider自动滑动开始到结束的时间（单位ms）
                            loop={true} //是否形成环路
                            navigation={{
                                nextEl: '.swiper-honor-next',
                                prevEl: '.swiper-honor-prev',
                            }}
                            observer={true} //修改swiper自己或子元素时，自动初始化swiper
                            observeParents={true} //修改swiper的父元素时，自动初始化swiper
                        >
                            {
                                dataList.map((item, index) => {
                                    return (
                                        <SwiperSlide key={index}>
                                            <div className="swiper-item">
                                                {
                                                    item.map((sonItem, sonIndex) => {
                                                        return (
                                                            <div className="item" key={sonIndex}>
                                                                <img src={sonItem} alt=""/>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                        <div className="control">
                            <div className="swiper-honor-prev">
                                <i className="iconfont icon-xinwenzhongxin-dianji"></i>
                            </div>
                            <div className="swiper-honor-next">
                                <i className="iconfont icon-xinwenzhongxin-dianji"></i>
                            </div>
                        </div>
                    </div>
                    <div className="tips">
                        与多家企业保持友好合作
                    </div>
                </div>
                <Footer></Footer>
            </div>
        );
    }
}

export default Cooperation;
